import React from "react";

const WebplaceContext = React.createContext({
  navbarItems: {},
  homeBanner: {},
  homeAboutus: {},
  homeShowcaseItems: {},
  homeNavOptionStyles: {},
  homeSocials: {},
  generalEmailInformation: {},
  locationInformation: {},
  cateringInformation: {},
  brandsInformation: {},
  footerInformation: {},
});

export default WebplaceContext;
